import IntroSection from './introSection';

export default IntroSection;
